module.exports = __webpack_public_path__ + "img/framee-all-old.94cdedfc.png";